// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Roles_invalidDataError__grHtX"};